import React from 'react';
import loadable from '@loadable/component';

interface ILeadFormSwitch {
  type: string;
  isPopup: boolean;
  isSidebar: boolean;
  autoBrandList?: any[];
  popularCarBrands?: any[];
  language: 'en' | 'id';
  isLoading?: boolean;
  leadFormCTA: string;
  handleLeadSubmit?: (data: any, leadPage?: string) => void;
}

const LeadFormSwitch = (props: ILeadFormSwitch) => {
  const {
    type,
    isPopup,
    isSidebar,
    autoBrandList,
    popularCarBrands,
    language,
    isLoading,
    leadFormCTA,
    handleLeadSubmit
  } = props;

  switch (type) {
  case 'auto':
  case 'auto_multistep_v1':
  case 'auto_multistep_v2':
  case 'auto_multistep_v3':
  case 'auto_multistep_v4':
  case 'auto_multistep_v5':
  case 'auto_multistep_v6': {
    const AutoLeadForm = loadable(() =>
      import('./Auto'));
    return (
      <AutoLeadForm
        type={type}
        isPopup={isPopup}
        language={language}
        isSidebar={isSidebar}
        autoBrandList={autoBrandList}
        popularCarBrands={popularCarBrands}
        isLoading={isLoading}
        leadFormCTA={leadFormCTA}
        handleLeadSubmit={(data, LeadPage) =>
          handleLeadSubmit(data, LeadPage)}
      />
    );
  }
  case 'life':
  case 'life_email':
  case 'life_fullname':
  case 'life_v2': {
    const LifeLeadForm = loadable(() =>
      import('./health/HealthLifeLeadForm'));
    return (
      <LifeLeadForm
        category="life"
        type={type}
        isPopup={isPopup}
        isSidebar={isSidebar}
        language={language}
        handleLeadSubmit={(data, LeadPage) =>
          handleLeadSubmit(data, LeadPage)}
      />
    );
  }
  case 'health':
  case 'health_email':
  case 'health_fullname':
  case 'health_v2': {
    const HealthLeadForm = loadable(() =>
      import('./health/HealthLifeLeadForm'));
    return (
      <HealthLeadForm
        category="health"
        type={type}
        isPopup={isPopup}
        isSidebar={isSidebar}
        language={language}
        isLoading={isLoading}
        handleLeadSubmit={(data, LeadPage) =>
          handleLeadSubmit(data, LeadPage)}
      />
    );
  }
  case 'travel':
  case 'syariah':
  case 'micro-rawat-inap': {
    const UnassistedForm = loadable(() =>
      import('./UnassistedForm'));
    return <UnassistedForm category={type} />;
  }
  case 'cargo':
  case 'property':
  case 'p_indemnity':
  case 'health_eb_v2': {
    const BusinessFormV2 = loadable(() =>
      import('./business/BusinessLeadFormV2'));
    return (
      <BusinessFormV2
        isPopup={isPopup}
        category={type}
        isLoading={isLoading}
        handleLeadSubmit={(data, LeadPage) =>
          handleLeadSubmit(data, LeadPage)}
      />
    );
  }
  case 'health_eb': {
    const BusinessLeadForm = loadable(() =>
      import('./business/BusinessLeadForm'));
    return (
      <BusinessLeadForm
        category={type}
        isPopup={isPopup}
        isLoading={isLoading}
        handleLeadSubmit={(data, LeadPage) =>
          handleLeadSubmit(data, LeadPage)}
      />
    );
  }
  case 'travel_v2': {
    const TravelFormV2 = loadable(() =>
      import('./TravelFormV2'));
    return (
      <TravelFormV2
        isLoading={isLoading}
        handleLeadSubmit={(data, LeadPage) =>
          handleLeadSubmit(data, LeadPage)}
      />
    );
  }
  case 'moto': {
    const MotoLeadForm = loadable(() =>
      import('./moto/MotoLeadForm'));
    return (
      <MotoLeadForm
        type={type}
        isPopup={isPopup}
        isSidebar={isSidebar}
        motoBrandList={autoBrandList}
        isLoading={isLoading}
        handleLeadSubmit={(data, LeadPage) =>
          handleLeadSubmit(data, LeadPage)}
      />
    );
  }
  default: {
    const HealthFullName = loadable(() =>
      import('./health/HealthLifeLeadForm'));
    return (
      <HealthFullName
        category="health"
        type="fullname"
        isPopup={isPopup}
        isSidebar={isSidebar}
        language={language}
        isLoading={isLoading}
        handleLeadSubmit={(data, LeadPage) =>
          handleLeadSubmit(data, LeadPage)}
      />
    );
  }
  }
};

export default LeadFormSwitch;
